// @flow

/**
 * Module dependencies.
 */

import { colors, units } from 'client/styles';
import { compose, defaultProps } from 'recompose';
import { h4 } from 'client/styles/type';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  source: string,
  themeColor?: string
};

/**
 * Theme default color.
 */

const defaultThemeColor = {
  primary: colors.brandPrimary,
  secondary: colors.shadesOfBlue.oxfordBlue
};

/**
 * `StyledMarkdown` component.
 */

const StyledMarkdown = styled.div`
  ${({ themeColor }) => `
    h5 {
      ${h4}
      font-weight: 300;
      color: ${themeColor.secondary} !important;
      margin: 0;
    }

    h1, h2, h3, h4 {
      color: ${themeColor.primary} !important;
      margin: 2.2em 0 .5em;

      &:first-child {
        margin-top: 0;
      }
    }

    h3 + h4 {
      margin-top: ${units(2.5)};
    }

    ul {
      list-style: none;
      padding-left: ${units(4)};

      > li {
        position: relative;

        &::before {
          background: ${themeColor.primary};
          content: '';
          height: 1px;
          left: ${units(-4)};
          position: absolute;
          top: .8em;
          width: ${units(2)};
        }
      }
    }
  `}
`;

/**
 * `Markdown` component.
 */

function Markdown(props: Props): React$Element<*> {
  const { source, themeColor } = props;

  return (
    <StyledMarkdown themeColor={themeColor}>
      <ReactMarkdown source={source} />
    </StyledMarkdown>
  );
}

/**
 * Export `Markdown`.
 */

export default compose(
  defaultProps({
    themeColor: defaultThemeColor
  })
)(Markdown);



// WEBPACK FOOTER //
// ../src/client/components/core/markdown/index.js